import * as React from "react";

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';


const useStyles = makeStyles(theme => ({
    container: (props) => {
      const size = getIconSize(props.size);
      return {
        alignItems: 'center',
        backgroundColor: "rgb(189, 189, 189)",
        borderRadius: getIconShape(size, props),
        color: "rgb(255, 255, 255)",
        display: 'flex',
        fontSize: size,
        justifyContent: 'center',
        minHeight: size,
        minWidth: size,
        padding: theme.spacing(props.p || 0),
        width: 'min-content'
      };
    }
  }));
  
  //
  // --- Helpers ---
  
  function getIconSize(size) {
    if (typeof size === 'number' && size > 0) {
      return size;
    }
    switch (size) {
      case 'sm':
        return 24;
      case 'default':
        return 40;
      case 'lg':
        return 56;
      case 'xl':
        return 96;
      default:
        return 24;
    }
  }
  
  function getIconShape(size, props) {
    const { shape, p = 0 } = props;
    switch (shape) {
      case 'rounded':
        return 5;
      case 'circle':
        return size + p / 2;
      default:
        return 0;
    }
  }


const IconBackground =(props)=>{
    const { children, className, style } = props;
  const classes = useStyles(props);
  const clonedChild = React.cloneElement(children, { color: 'rgb(255, 255, 255)', fontSize: 'inherit' });
  return(
    <div style={style} className={clsx(classes.container, className)}>
      {clonedChild}
    </div>
  )
}

IconBackground.defaultProps = {
    color: 'white',
    shape: 'square',
    size: 'default',
    p: 0
  };

export { IconBackground };
